import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from 'react-bootstrap';
import { putRequest } from '../../../requestUtils';
import climbingLadder from '../../../../assets/images/climbing-the-ladder.png';
import './ProposalQuestion.scss';
var ProposalQuestion = /*#__PURE__*/function (_Component) {
  function ProposalQuestion(props) {
    var _this;
    _classCallCheck(this, ProposalQuestion);
    _this = _callSuper(this, ProposalQuestion, [props]);
    _this.state = {
      showModal: props.modalIsOpen,
      question: '',
      isProcessing: false
    };
    _this.handleHideModal = _this.handleHideModal.bind(_this);
    _this.handleShowModal = _this.handleShowModal.bind(_this);
    _this.handleClearDisplayMessage = _this.handleClearDisplayMessage.bind(_this);
    _this.handleOnChange = _this.handleOnChange.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    return _this;
  }
  _inherits(ProposalQuestion, _Component);
  return _createClass(ProposalQuestion, [{
    key: "handleClearDisplayMessage",
    value: function handleClearDisplayMessage() {
      var _this2 = this;
      setTimeout(function () {
        _this2.setState({
          errorMessage: '',
          succesMessage: ''
        });
      }, 6000);
    }
  }, {
    key: "handleHideModal",
    value: function handleHideModal() {
      var showModalCallback = this.props.showModalCallback;
      if (showModalCallback) {
        showModalCallback();
      }
      this.setState({
        showModal: false
      });
    }
  }, {
    key: "handleShowModal",
    value: function handleShowModal() {
      var showModalCallback = this.props.showModalCallback;
      if (showModalCallback) {
        showModalCallback();
      }
      this.setState({
        showModal: true
      });
    }
  }, {
    key: "handleOnChange",
    value: function handleOnChange(value) {
      this.setState({
        question: value
      });
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      var _this3 = this;
      var _this$props = this.props,
        url = _this$props.url,
        csrfToken = _this$props.csrfToken;
      var question = this.state.question;
      this.setState({
        isProcessing: true
      });
      putRequest(url, {
        question: question
      }, csrfToken).then(function (_ref) {
        var data = _ref.data;
        _this3.setState({
          isProcessing: false,
          question: '',
          succesMessage: data.message
        });
        // Notify other components (e.g., Messages tab) to refetch
        try {
          window.dispatchEvent(new CustomEvent('proposal:question_sent'));
        } catch (e) {/* no-op */}
        _this3.handleClearDisplayMessage();
      })["catch"](function (_ref2) {
        var message = _ref2.message;
        _this3.setState({
          isProcessing: false,
          errorMessage: message
        });
        _this3.handleClearDisplayMessage();
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      var _this$state = this.state,
        showModal = _this$state.showModal,
        succesMessage = _this$state.succesMessage,
        errorMessage = _this$state.errorMessage,
        question = _this$state.question,
        isProcessing = _this$state.isProcessing;
      var disableSendQuestionBtn = question === '';
      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "proposal-question"
      }, /*#__PURE__*/React.createElement("div", {
        className: "header"
      }, "Questions about this candidate?"), /*#__PURE__*/React.createElement("div", {
        className: "body-content"
      }, /*#__PURE__*/React.createElement("img", {
        src: climbingLadder,
        alt: "climbing ladder"
      }), /*#__PURE__*/React.createElement("div", {
        className: "question-info"
      }, "We\u2019re here to help! If we don\u2019t know the answer, we can contact Olga to find out.")), /*#__PURE__*/React.createElement(Button, {
        className: "btn-ask-question",
        onClick: this.handleShowModal
      }, "Ask us a Question")), /*#__PURE__*/React.createElement(Modal, {
        show: showModal,
        onHide: this.handleHideModal,
        dialogClassName: "proposal-question-modal",
        size: "lg"
      }, /*#__PURE__*/React.createElement(Modal.Header, {
        closeButton: true
      }), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement("div", {
        className: "header"
      }, "Ask a question about this candidate / proposal"), /*#__PURE__*/React.createElement("div", {
        className: "body-text"
      }, "What questions do you have about this candidate or proposal? We\u2019ll contact you soon with a response.", /*#__PURE__*/React.createElement("strong", null, " Only Clora will see your question/comments.")), /*#__PURE__*/React.createElement("textarea", {
        className: "proposal-question-textarea",
        rows: "3",
        placeholder: "Type your question here...",
        value: question,
        onChange: function onChange(event) {
          return _this4.handleOnChange(event.target.value);
        }
      }), succesMessage && /*#__PURE__*/React.createElement("div", {
        className: "success-message"
      }, succesMessage), errorMessage && /*#__PURE__*/React.createElement("div", {
        className: "error-message"
      }, errorMessage)), /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement(Button, {
        className: "".concat(disableSendQuestionBtn ? 'btn btn-disabled' : 'btn-send-question'),
        onClick: this.handleSubmit
      }, "Send question", isProcessing ? '...' : ''))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.modalIsOpen && !prevState.showModal) {
        return {
          showModal: true
        };
      }
      return null;
    }
  }]);
}(Component);
ProposalQuestion.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  modalIsOpen: PropTypes.bool,
  showModalCallback: PropTypes.func
};
ProposalQuestion.defaultProps = {
  modalIsOpen: false,
  showModalCallback: function showModalCallback() {}
};
export default ProposalQuestion;